module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mp-b0a5ed44db6410228f23d1f2676aeded.svg";